import { useQuery } from '@tanstack/react-query';
import { getPrivatePulse5Dashboards, getPublicPulse5Dashboards } from '@src/api/dashboards';
import { PRIVATE_SAVED_DASHBOARDS_KEY, PUBLIC_SAVED_DASHBOARDS_KEY } from './utils';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';

export const SAVED_DASHBOARDS_TAB_KEY = 'saved-dashboards-tab';

const queryFunctions = {
  [PRIVATE_SAVED_DASHBOARDS_KEY]: getPrivatePulse5Dashboards,
  [PUBLIC_SAVED_DASHBOARDS_KEY]: getPublicPulse5Dashboards,
};

function useGetSavedDashboardsList({ dashboardTabKey }) {
  const dataSource = CURRENT_PRODUCT_MODE.toLocaleLowerCase();

  // TODO: update API to return based on product
  const { data, isLoading, isError } = useQuery(
    ['saved-dashboards-tab', dashboardTabKey],
    queryFunctions[dashboardTabKey],
    {
      // sd-todo: tune the settings here
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: dashboardTabKey in queryFunctions,
      select: (response) => {
        const dashboards = response.data || [];
        if (dataSource === 'all') return dashboards;
        return dashboards.filter((it) => it.productName === dataSource) as any[];
      },
    },
  );

  return {
    data,
    isLoading,
    isError,
  };
}

export default useGetSavedDashboardsList;
